import { Phone, Mail, Facebook, Instagram, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { IMAGES, PHONE, PHONE_HREF, EMAIL, SOCIALS } from "../site";

const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
  </svg>
);

const SOCIAL_ICONS = { tiktok: TikTokIcon, instagram: Instagram, facebook: Facebook };

export const Footer = () => (
  <footer className="border-t border-zinc-800/80 bg-[#070709]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 py-14">
      <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-10">
        <div className="max-w-sm">
          <div className="flex items-center gap-3 mb-4">
            <img src={IMAGES.logo} alt="ETN Customz logo" className="h-12 w-12 object-cover clip-corner border border-zinc-700" />
            <span className="font-display text-3xl font-black uppercase italic tracking-tight text-white">
              ETN<span className="text-volt"> Customz</span>
            </span>
          </div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 leading-relaxed">
            Lifts · Lighting · Wheels · Tires · Audio & Subs · Accessories
          </p>
          <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
            Eastern Tennessee diesel mechanic and custom truck outfitter. Lifts, levels and lighting, done right.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-volt mb-1">Contact</p>
          <a href={PHONE_HREF} data-testid="footer-phone-link" className="flex items-center gap-3 text-zinc-300 hover:text-volt transition-colors">
            <Phone size={16} /> {PHONE}
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 text-zinc-300 hover:text-volt transition-colors break-all">
            <Mail size={16} className="shrink-0" /> {EMAIL}
          </a>
          <Link to="/contact" data-testid="footer-quote-link" className="flex items-center gap-3 text-zinc-300 hover:text-volt transition-colors">
            <Zap size={16} /> Request a build quote
          </Link>
        </div>

        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-volt mb-4">Follow the builds</p>
          <div className="flex flex-col gap-3">
            {SOCIALS.map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              return (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-${s.id}-link`}
                  className="group flex items-center gap-3 text-zinc-300 hover:text-bolt-bright transition-colors"
                >
                  <span className="flex h-9 w-9 items-center justify-center clip-corner border border-zinc-700 group-hover:border-bolt transition-colors">
                    <Icon size={16} />
                  </span>
                  <span className="text-sm">{s.handle}</span>
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-zinc-800/80 pt-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-600">
          © {new Date().getFullYear()} Eastern TN Customz LLC
        </p>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-600">
          Built loud in East Tennessee
        </p>
      </div>
    </div>
  </footer>
);
